class CartRestriction {
    constructor() {
        this.bindPopupAddToCartBtn();
    }

    static checkTag(tag) {
        // Convert Pre-order Month tag into proper month text for Add-to-cart Pop-up
        if (tag.toLowerCase().includes('01a')) {
            return 'JANUARY';
        } else if (tag.toLowerCase().includes('02a')) {
            return 'FEBRUARY';
        } else if (tag.toLowerCase().includes('03a')) {
            return 'MARCH';
        } else if (tag.toLowerCase().includes('04a')) {
            return 'APRIL';
        } else if (tag.toLowerCase().includes('05a')) {
            return 'MAY';
        } else if (tag.toLowerCase().includes('06a')) {
            return 'JUNE';
        } else if (tag.toLowerCase().includes('07a')) {
            return 'JULY';
        } else if (tag.toLowerCase().includes('08a')) {
            return 'AUGUST';
        } else if (tag.toLowerCase().includes('09a')) {
            return 'SEPTEMBER';
        } else if (tag.toLowerCase().includes('10a')) {
            return 'OCTOBER';
        } else if (tag.toLowerCase().includes('11a')) {
            return 'NOVEMBER';
        } else if (tag.toLowerCase().includes('12a')) {
            return 'DECEMBER';
        }

        return false;
    }

    bindPopupAddToCartBtn() {
        const continue_btn = document.querySelector('.btn-continue');
        const change_btn = document.querySelector('.btn-change');

        const popupAddToCart = document.querySelector('#PopupAddToCart');

        // When restriction pop-up is closed, reset quantity input to 0 if the cart type is not changed
        // This is to avoid restriction logic issue when quantity input changes from x to 0
        continue_btn.addEventListener('click', function () {
            popupAddToCart.hide();
            document.querySelectorAll('.quantity__input').forEach((input) => {
                input.value = 0;
            });
        });

        const popupCloseBtn = document.querySelector('#ModalClose-PopupAddToCart');
        popupCloseBtn.addEventListener('click', function () {
            document.querySelectorAll('.quantity__input').forEach((input) => {
                input.value = 0;
            });
        });

        change_btn.addEventListener('click', function () {
            // Clear the cart before adding new items
            fetch(`/cart/clear.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
            })
                .then((response) => response.text())
                .then((res) => {
                    const checkCartType = window.sessionStorage.getItem('mrRestrictionCheckCartType');

                    if (checkCartType === 'quick-add') {
                        // If restriction pop-up is triggered from quick add to cart grid
                        const items = JSON.parse(window.sessionStorage.getItem('mrRestrictionItemsToAdd'));
                        const cartType = window.sessionStorage.getItem('mrRestrictionCartTypeToUpdate');
                        const hasSb3pl = window.sessionStorage.getItem('mrRestrictionHasSb3plToUpdate') === 'true'; // Convert string to boolean

                        // Global function 'quickAddCheckCartCallBack' refers to
                        // the callback function in quick-order-list.js or quick-add-bulk.js
                        window.quickAddCheckCartCallBack(items, cartType, hasSb3pl);
                    }

                    if (checkCartType === 'product-form') {
                        // If restriction pop-up is triggered from PDP Add to Cart button
                        document.querySelector('[data-type="add-to-cart-form"]').submit();
                    }

                    popupAddToCart.hide();
                })
                .catch((error) => {
                    console.log(error)
                });
        });
    }

    // Check cart_type 'Preorder' and 'Instock' & has_sb3pl 'true' or 'false' function for quick add to cart grid
    quickAddCheckCart(items, cartType, hasSb3pl, callback) {
        fetch(`/cart.js`)
            .then((response) => response.json())
            .then((res) => {
                if (res.items.length == 0) {
                    console.log('no item in cart');
                    callback(items, cartType, hasSb3pl);
                    return;
                }

                // Get 'cart_type' attribute from the existing cart
                const existingCartType = res.attributes?.cart_type;

                // Get 'has_sb3pl' attribute from the existing cart
                // has_sb3pl is to show whether products having 'SB3PL' tag are in the cart
                const existingHasSb3pl = res.attributes?.has_sb3pl;

                // Get B2B company shipping country code for SB3PL cart restriction
                const b2bCompanyShippingCountry = window.b2bCompanyAddress?.country_code;

                if (existingCartType === cartType) {

                    // SB3PL cart restriction only applies to AU B2B customers
                    if (b2bCompanyShippingCountry !== 'AU' ||
                        existingHasSb3pl === hasSb3pl) {

                        console.log('same cart type or same sb3pl status or b2b country code is ', b2bCompanyShippingCountry);
                        callback(items, cartType, hasSb3pl);
                        return;
                    }
                }

                const continue_btn = document.querySelector('.btn-continue');
                const change_btn = document.querySelector('.btn-change');

                // Save the cart type, SB3PL status & items to session storage to be used in #PopupAddToCart
                window.sessionStorage.setItem('mrRestrictionCheckCartType', 'quick-add');
                window.sessionStorage.setItem('mrRestrictionCartTypeToUpdate', cartType);
                window.sessionStorage.setItem('mrRestrictionHasSb3plToUpdate', hasSb3pl);
                window.sessionStorage.setItem('mrRestrictionItemsToAdd', JSON.stringify(items));

                // Assign callback function to global function to be used in #PopupAddToCart
                window.quickAddCheckCartCallBack = callback;

                console.log('existingCartType: ', existingCartType, 'cartType: ', cartType, 'hasSb3pl: ', hasSb3pl);

                // Flag to check if the Pre-order/In-stock restriction pop-up is active
                let restrictionPopupActiveFlag = false;

                /* PRE-ORDER / IN-STOCK CART RESTRICTION */

                if (existingCartType !== 'instock' && cartType === 'instock') {
                    continue_btn.innerText = 'CONTINUE WITH PRE-ORDER';
                    change_btn.innerText = 'CHANGE TO IN-STOCK';
                    document.querySelector(".preorder-instock-message").style.display = "block";
                    restrictionPopupActiveFlag = true;
                }
                if (existingCartType === 'instock' && cartType !== 'instock') {
                    continue_btn.innerText = 'CONTINUE WITH IN-STOCK';
                    change_btn.innerText = 'CHANGE TO PRE-ORDER';
                    document.querySelector(".preorder-instock-message").style.display = "block";
                    restrictionPopupActiveFlag = true;
                }
                if (existingCartType !== 'instock' &&
                    cartType !== 'instock' &&
                    existingCartType !== cartType) {

                    const preOrderMonthInCart = CartRestriction.checkTag(existingCartType);
                    const preOrderMonthInPDP = CartRestriction.checkTag(cartType);

                    // If Pre-order Month tag in the cart is different than the Pre-order Month tag on PDP, display a pop-up
                    continue_btn.innerText = 'CONTINUE WITH ' + preOrderMonthInCart + ' COLLECTION';
                    change_btn.innerText = 'CHANGE TO ' + preOrderMonthInPDP + ' COLLECTION';
                    document.querySelector(".preorder-monthly-collection-message").style.display = "block";
                    restrictionPopupActiveFlag = true;
                }

                /* SB3PL CART RESTRICTION */

                // This condition is to prevent products with 'SB3PL' tags from being in the same cart with products without 'SB3PL' tags
                // SB3PL restriction pop-up only show up if Pre-order / In-stock restriction pop-up is not active
                if (!restrictionPopupActiveFlag &&
                    b2bCompanyShippingCountry === 'AU' &&
                    existingHasSb3pl !== hasSb3pl) {

                    continue_btn.innerText = `CONTINUE WITH ${existingHasSb3pl ? 'SNUGGLE BUNNIES CART': 'CART WITHOUT SNUGGLE BUNNIES'}`;
                    change_btn.innerText = `CHANGE TO ${hasSb3pl ? 'SNUGGLE BUNNIES CART': 'CART WITHOUT SNUGGLE BUNNIES'}`;
                    document.querySelector(".sb3pl-restriction-message").style.display = "block";
                }

                callback([]);
                const popupAddToCart = document.querySelector('#PopupAddToCart');
                popupAddToCart.show();
                return;
            });
    }

    // Check cart_type 'Preorder' and 'Instock' & has_sb3pl 'true' or 'false' function for product form on PDP
    // 'this' is bound to 'ProductForm' class in product-form.js
    productFormCheckCart(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        fetch(`/cart.js`)
            .then((response) => response.json())
            .then((res) => {

                const cartType = this.getAttribute('data-preorder-collection-date') ?? this.getAttribute('data-product-type') ?? 'instock';

                // Check if the items have the 'SB3PL' tag
                const hasSb3pl = this.hasAttribute('data-has-sb3pl');

                if (res.items.length > 0) {
                    const existingCartType = res.attributes?.cart_type;
                    window.sessionStorage.setItem('mrRestrictionCheckCartType', 'product-form');
                    console.log('existingCartType: ', existingCartType, 'cartType: ', cartType, 'hasSb3pl: ', hasSb3pl);

                    // Flag to check if the Pre-order/In-stock restriction pop-up is active
                    let restrictionPopupActiveFlag = false;

                    /* PRE-ORDER / IN-STOCK CART RESTRICTION */

                    if ((existingCartType !== 'instock') && (cartType === 'instock')) {
                        continue_btn.innerText = 'CONTINUE WITH PRE-ORDER';
                        change_btn.innerText = 'CHANGE TO IN-STOCK';
                        document.querySelector(".preorder-instock-message").style.display = "block";
                        restrictionPopupActiveFlag = true;
                    }
                    if ((existingCartType === 'instock') && (cartType !== 'instock')) {
                        continue_btn.innerText = 'CONTINUE WITH IN-STOCK';
                        change_btn.innerText = 'CHANGE TO PRE-ORDER';
                        document.querySelector(".preorder-instock-message").style.display = "block";
                        restrictionPopupActiveFlag = true;
                    }

                    if (existingCartType !== 'instock' &&
                        cartType !== 'instock' &&
                        existingCartType !== cartType) {

                        const preOrderMonthInCart = CartRestriction.checkTag(existingCartType);
                        const preOrderMonthInPDP = CartRestriction.checkTag(cartType);

                        // If Pre-order Month tag in the cart is different than the Pre-order Month tag on PDP, display a pop-up
                        continue_btn.innerText = 'CONTINUE WITH ' + preOrderMonthInCart + ' COLLECTION';
                        change_btn.innerText = 'CHANGE TO ' + preOrderMonthInPDP + ' COLLECTION';
                        document.querySelector(".preorder-monthly-collection-message").style.display = "block";
                        restrictionPopupActiveFlag = true;
                    }

                    /* SB3PL CART RESTRICTION */

                    // Get 'has_sb3pl' attribute from the existing cart
                    // has_sb3pl is to show whether products having 'SB3PL' tag are in the cart
                    const existingHasSb3pl = res.attributes?.has_sb3pl;

                    // Get B2B company shipping country code for SB3PL cart restriction
                    const b2bCompanyShippingCountry = window.b2bCompanyAddress?.country_code;

                    // This condition is to prevent products with 'SB3PL' tags from being in the same cart with products without 'SB3PL' tags
                    // SB3PL cart restriction only applies to AU B2B customers
                    if (!restrictionPopupActiveFlag &&
                        b2bCompanyShippingCountry === 'AU' &&
                        existingHasSb3pl !== hasSb3pl) {

                        continue_btn.innerText = `CONTINUE WITH ${existingHasSb3pl ? 'SNUGGLE BUNNIES CART': 'CART WITHOUT SNUGGLE BUNNIES'}`;
                        change_btn.innerText = `CHANGE TO ${hasSb3pl ? 'SNUGGLE BUNNIES CART': 'CART WITHOUT SNUGGLE BUNNIES'}`;
                        document.querySelector(".sb3pl-restriction-message").style.display = "block";
                    }

                    const popupAddToCart = document.querySelector('#PopupAddToCart');
                    popupAddToCart.show();
                    return;
                }

                this.handleErrorMessage();

                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.classList.add('loading');
                this.querySelector('.loading__spinner').classList.remove('hidden');

                const config = fetchConfig('javascript');
                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                delete config.headers['Content-Type'];

                const formData = new FormData(this.form);
                formData.append('attributes[cart_type]', cartType);
                formData.append('attributes[has_sb3pl]', hasSb3pl);
                if (this.cart) {
                    formData.append(
                        'sections',
                        this.cart.getSectionsToRender().map((section) => section.id)
                    );
                    formData.append('sections_url', window.location.pathname);
                    this.cart.setActiveElement(document.activeElement);
                }
                config.body = formData;
                fetch(`${routes.cart_add_url}`, config)
                    .then((response) => response.json())
                    .then((response) => {
                        if (response.status) {
                            publish(PUB_SUB_EVENTS.cartError, {
                                source: 'product-form',
                                productVariantId: formData.get('id'),
                                errors: response.errors || response.description,
                                message: response.message,
                            });
                            this.handleErrorMessage(response.description);

                            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                            if (!soldOutMessage) return;
                            this.submitButton.setAttribute('aria-disabled', true);
                            this.submitButtonText.classList.add('hidden');
                            soldOutMessage.classList.remove('hidden');
                            this.error = true;
                            return;
                        } else if (!this.cart) {
                            window.location = window.routes.cart_url;
                            return;
                        }

                        if (!this.error)
                            publish(PUB_SUB_EVENTS.cartUpdate, {
                                source: 'product-form',
                                productVariantId: formData.get('id'),
                                cartData: response,
                            });
                        this.error = false;
                        const quickAddModal = this.closest('quick-add-modal');
                        if (quickAddModal) {
                            document.body.addEventListener(
                                'modalClosed',
                                () => {
                                    setTimeout(() => {
                                        this.cart.renderContents(response);
                                    });
                                },
                                { once: true }
                            );
                            quickAddModal.hide(true);
                        } else {
                            this.cart.renderContents(response);
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                    })
                    .finally(() => {
                        this.submitButton.classList.remove('loading');
                        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                        this.querySelector('.loading__spinner').classList.add('hidden');
                    });
            })
    }
}

window.mrCartRestriction = new CartRestriction();
console.log('Cart Restriction loaded');